<template>
  <div>
    <div class="wrapper d-flex flex-column align-center mx-2">
      <h1 class="mt-10">Εγγραφή</h1>

      <v-form @submit.prevent="submit">
        <div class="d-flex flex-column fields">
          <v-text-field
            color="rgb(0,170,221)"
            label="Email"
            v-model="email"
            prepend-inner-icon="mdi-email-outline"
            :error-messages="emailErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Συνθηματικό"
            type="password"
            v-model="password"
            prepend-inner-icon="mdi-lock-outline"
            :error-messages="passwordErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Επιβεβαίωση συνθηματικού"
            type="password"
            v-model="confirmPassword"
            prepend-inner-icon="mdi-lock-outline"
            :error-messages="confirmPasswordErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Όνομα"
            v-model="firstName"
            :error-messages="firstNameErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Επώνυμο"
            v-model="lastName"
            :error-messages="lastNameErrors"
          ></v-text-field>
          <v-text-field
            prefix="(+30)"
            color="rgb(0,170,221)"
            label="Κινητό"
            v-model="mobile"
            :error-messages="mobileErrors"
          ></v-text-field>
          <v-autocomplete
            color="rgb(0,170,221)"
            label="Νομός εργασίας"
            :items="prefectures"
            item-value="option_key"
            item-text="option_value"
            v-model="prefecture"
            @change="getMunicipalities"
            :error-messages="prefectureErrors"
          ></v-autocomplete>

          <v-autocomplete
            color="rgb(0,170,221)"
            label="Δήμος εργασίας"
            v-model="municipalityCode"
            :items="municipalities"
            item-value="option_key"
            item-text="option_value"
            :loading="loadingLocal"
            :disabled="!prefecture"
            :error-messages="municipalityCodeErrors"
          ></v-autocomplete>

          <h2 v-if="!isPsychologist" class="mb-0 mt-5">Είμαι</h2>

          <v-radio-group v-if="!isPsychologist" v-model="isPublicSectorEmployee">
            <v-radio label="Γιατρός Ε.Σ.Υ." color="rgb(0,170,221)" :value="true"></v-radio>
            <v-radio label="Ιδιωτικός Γιατρός" color="rgb(0,170,221)" :value="false"></v-radio>
          </v-radio-group>

          <v-checkbox color="rgb(0,170,221)" label="Ψυχολόγος" v-model="isPsychologist"></v-checkbox>

          <v-autocomplete
            color="rgb(0,170,221)"
            :items="doctorTypes"
            item-value="option_key"
            item-text="option_value"
            label="Ειδικότητα"
            v-model="docLicenseType"
            :disabled="isPsychologist"
            :error-messages="docLicenseTypeErrors"
          ></v-autocomplete>
          <!-- <v-text-field
            color="rgb(0,170,221)"
            label="Ιατρικός σύλλογος"
            v-model="docMedicalAssociation"
            :disabled="isPsychologist"
            :error-messages="docMedicalAssociationErrors"
          ></v-text-field> -->
          <v-autocomplete
            color="rgb(0,170,221)"
            :items="medicalAssociations"
            item-value="option_key"
            item-text="option_value"
            label="Ιατρικός σύλλογος"
            v-model="docMedicalAssociation"
            :disabled="isPsychologist"
            :error-messages="docMedicalAssociationErrors">
          </v-autocomplete>

          <v-text-field
            color="rgb(0,170,221)"
            label="Αρ. Μητρώου Ιατρικού Συλλόγου"
            v-model="idNumber"
            :disabled="isPsychologist"
            :error-messages="idNumberErrors"
          ></v-text-field>

          <div class="mt-12 d-flex align-center">
            <v-checkbox
              height="10"
              v-model="terms"
              :error-messages="termsErrors"
              color="rgb(0,170,221)"
            >
              <template slot="label">
                <p class="mb-0 black--text" style="font-size:14px">
                  Συμφωνώ με τους
                  <span
                    @click.prevent="termsDialog=true"
                    class="font-weight-bold"
                    style="color:rgb(0,170,221);"
                  >Όρους και προϋποθέσεις</span>
                </p>
              </template>
            </v-checkbox>
          </div>

          <div class="d-flex align-center">
            <v-checkbox
              height="10"
              v-model="policy"
              :error-messages="policyErrors"
              color="rgb(0,170,221)"
            >
              <template slot="label">
                <p class="mb-0 black--text" style="font-size:14px">
                  Συμφωνώ με την
                  <span
                    @click.stop="privacyDialog=true"
                    class="font-weight-bold"
                    style="color:rgb(0,170,221); cursor:pointer"
                  >Πολιτική απορρήτου</span> της εταιρείας
                </p>
              </template>
            </v-checkbox>
          </div>

          <div class="align-self-center my-5">
            <vue-recaptcha
              sitekey="6LeqxOQUAAAAAHuqe3GbWMUANvKvtmc79l27dWKq"
              :loadRecaptchaScript="true"
              size="100"
              @verify="verify"
            ></vue-recaptcha>
          </div>

          <div class="d-flex justify-center mt-5">
            <v-btn
              rounded
              depressed
              outlined
              height="40"
              width="100"
              color="rgb(0,170,221)"
              class="text-capitalize"
              @click="$router.go(-1)"
            >
              <p class="mb-0">Πίσω</p>
            </v-btn>
            <v-btn
              type="submit"
              class="white--text text-capitalize ml-5"
              rounded
              depressed
              width="200"
              color="rgb(0,170,221)"
              height="40"
              :disabled="!enabled"
              :loading="$store.state.loading"
            >
              <p class="mb-0">Εγγραφή</p>
            </v-btn>
          </div>
        </div>
      </v-form>
    </div>

    <v-dialog v-model="termsDialog">
      <v-card>
        <v-card-text>
          <v-icon
            style="position:sticky; left:1px; top:20px; cursor:pointer;"
            @click="termsDialog=false"
          >mdi-close</v-icon>
          <Terms class="pt-5 ml-8" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="privacyDialog">
      <v-card>
        <v-card-text>
          <v-icon
            style="position:sticky;left:1px;top:10px; cursor:pointer;"
            @click="privacyDialog=false"
          >mdi-close</v-icon>
          <Privacy class="pt-10" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import Terms from "@/components/Terms.vue";
import Privacy from "@/components/Privacy.vue";
import * as firebase from "firebase";
import VueRecaptcha from "vue-recaptcha";
import {
  required,
  sameAs,
  email,
  numeric,
  minLength,
  maxLength,
  requiredUnless
} from "vuelidate/lib/validators";

const signUpValidator = function() {
  return !this.signUpFailed;
};

export default {
  mixins: [validationMixin],
  components: {
    Terms,
    Privacy,
    VueRecaptcha
  },
  created() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/optionsList/greekPrefectures/el`)
      .then(res => {
        this.prefectures = res.data;

        return axios.get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/doctorTypes/el`
        );
      })
      .then(res => {
        console.log(res);
        this.doctorTypes = res.data;
        return axios.get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMedicalAssociations/el`
        );
      })
      .then(res => {
        console.log("assos", res);
        this.medicalAssociations = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  data() {
    return {
      loadingLocal: false,

      signUpFailed: false,

      termsDialog: false,
      privacyDialog: false,

      prefectures: [],
      prefecture: null,
      municipalities: [],
      doctorTypes: [],
      isPsychologist: false,

      email: "",
      password: "",
      confirmPassword: "",

      municipalityCode: "",

      firstName: "",
      lastName: "",
      mobile: "",

      docLicenseType: "",
      docMedicalAssociation: "",
      idNumber: "",

      medicalAssociations: [],

      isPublicSectorEmployee: true,

      policy: false,
      terms: false,

      enabled: false
    };
  },
  methods: {
    getMunicipalities() {
      this.loadingLocal = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalitiesOfPrefecture/el/${this.prefecture}`
        )
        .then(res => {
          this.loadingLocal = false;
          this.municipalities = res.data;
        })
        .catch(err => {
          this.loadingLocal = false;
          console.log(err);
        });
    },
    verify() {
      this.enabled = true;
    },
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const registerObj = {
          email: this.email,
          password: this.password,
          application: "app_doctor",
          preferredLanguage: {
            languageIsoCode: "el"
          },
          operatingSystem: "web"
        };

        const doctorProfile = {
          userProfile: {
            firstName: this.firstName,
            lastName: this.lastName,
            taxId: "123",
            mobileCountry: "EN",
            mobile: this.mobile
          },
          doctorAccredations: {
            docLicenseType: this.isPsychologist ? 99 : this.docLicenseType,
            greekMedicalAssociationId: this.isPsychologist
              ? ""
              : this.docMedicalAssociation,
            idNumberType: "amka",
            idNumber: this.isPsychologist ? "" : this.idNumber
          },
          isPublicSectorEmployee: this.isPsychologist
            ? false
            : this.isPublicSectorEmployee,
          currentLocation: {
            municipalityCode: this.municipalityCode
          }
        };

        this.$store
          .dispatch("userRegister", registerObj)
          .then(res => {
            console.log("userRegister", res);
            return this.$store.dispatch("doctorProfile", {
              obj: doctorProfile,
              token: this.$store.state.token
            });
          })
          .then(res => {
            console.log("doctorProfile", res);

            return this.$store.dispatch(
              "agreeWithTerms",
              this.$store.state.token
            );
          })
          .then(res => {
            firebase.analytics().logEvent("sign_up");
            this.$router.push("/register/verification");
            console.log(res);
          })
          .catch(err => {
            if (err.response.data.errorCode === 10401) {
              this.signUpFailed = true;
            }

            console.log(err);
          });
      } else {
        window.scrollTo(0, 0);
      }
    }
  },

  validations: {
    email: {
      required,
      email,
      signUpValidator
    },
    password: {
      required,
      minLength: minLength(4)
    },
    confirmPassword: {
      required,
      minLength: minLength(4),
      sameAsPassword: sameAs("password")
    },
    firstName: {
      required
    },
    lastName: {
      required
    },
    mobile: {
      minLength: minLength(10),
      maxLength: maxLength(10),
      numeric
    },
    prefecture: {
      required
    },
    municipalityCode: {
      required
    },

    //if not psychologist
    docLicenseType: {
      required: requiredUnless("isPsycho")
    },
    docMedicalAssociation: {
      required: requiredUnless("isPsycho")
    },
    idNumber: {
      required: requiredUnless("isPsycho")
    },
    terms: { checked: value => value === true },
    policy: { checked: value => value === true }
  },

  computed: {
    isPsycho() {
      return this.isPsychologist;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.email.email) errors.push("Πρέπει να είναι σωστό email");
      if (!this.$v.email.signUpValidator)
        errors.push("Αυτό το email χρησιμοποιείται ήδη");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.password.minLength)
        errors.push("Πρέπει να είναι τουλάχιστον 4 χαρακτήρες");
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      if (!this.$v.confirmPassword.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.confirmPassword.minLength)
        errors.push("Πρέπει να είναι τουλάχιστον 4 χαρακτήρες");
      if (!this.$v.confirmPassword.sameAsPassword)
        errors.push("Πρέπει να είναι ίδιο με το συνθηματικό");
      return errors;
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      if (!this.$v.firstName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      if (!this.$v.mobile.minLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.maxLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.numeric) errors.push("Πρέπει να είναι αριθμός");
      return errors;
    },

    prefectureErrors() {
      const errors = [];
      if (!this.$v.prefecture.$dirty) return errors;
      if (!this.$v.prefecture.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    municipalityCodeErrors() {
      const errors = [];
      if (!this.$v.municipalityCode.$dirty) return errors;
      if (!this.$v.municipalityCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    //if not psychologist
    docLicenseTypeErrors() {
      const errors = [];
      if (!this.$v.docLicenseType.$dirty) return errors;
      if (!this.$v.docLicenseType.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    docMedicalAssociationErrors() {
      const errors = [];
      if (!this.$v.docMedicalAssociation.$dirty) return errors;
      if (!this.$v.docMedicalAssociation.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    idNumberErrors() {
      const errors = [];
      if (!this.$v.idNumber.$dirty) return errors;
      if (!this.$v.idNumber.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    termsErrors() {
      const errors = [];
      if (!this.$v.terms.$dirty) return errors;
      if (!this.$v.terms.checked) errors.push("");
      return errors;
    },
    policyErrors() {
      const errors = [];
      if (!this.$v.policy.$dirty) return errors;
      if (!this.$v.policy.checked) errors.push("");
      return errors;
    }
  },
  watch: {
    email(newValue, oldValue) {
      if ((oldValue !== "" && newValue === "") || newValue !== oldValue) {
        this.signUpFailed = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fields {
  position: relative;
  padding-bottom: 56px;
}

.buttonContainer {
  width: 100%;
  padding: 10px 0;
  bottom: 0;
  left: 0;
  position: absolute;
  background-color: #fff;
}
</style>